<div
  id="register-demo-wrapper"
  [attr.data-cy]="'step-' + (currentStep$ | async)">
  <!-- Configure Demo Step -->
  <ng-container *ngIf="(currentStep$ | async) === DemoSetupStep.CONFIGURE_DEMO">
    <div
      class="step-container"
      data-cy="configure-demo-step">
      <h1 data-cy="configure-demo-title">
        {{ ("configureDemoTitle" | i18n) || "Demo konfigurieren" }}
      </h1>

      <mat-form-field class="light-form-field">
        <mat-label>{{
          ("organisationNameLabel" | i18n) || "Wie heisst deine Organisation?"
        }}</mat-label>
        <input
          matInput
          [(ngModel)]="organisationName"
          type="text"
          required
          data-cy="organisation-name-input" />
      </mat-form-field>

      <mat-form-field class="light-form-field">
        <mat-label>{{
          ("organisationTypeQuestion" | i18n) || "Art des Unternehmens"
        }}</mat-label>
        <mat-select
          [(ngModel)]="organisationType"
          name="organisationType"
          required
          data-cy="organisation-type-select"
          [attr.data-cy-selected]="organisationType || 'none'">
          <mat-option
            [value]="DemoOrganisationType.AGENCY"
            data-cy="organisation-type-agency">
            {{ "demoOrganisationType.AGENCY" | i18n }}
          </mat-option>
          <mat-option
            [value]="DemoOrganisationType.HOSPITAL"
            data-cy="organisation-type-hospital">
            {{ "demoOrganisationType.HOSPITAL" | i18n }}
          </mat-option>
          <mat-option
            [value]="DemoOrganisationType.PSYCHIATRY"
            data-cy="organisation-type-psychiatry">
            {{ "demoOrganisationType.PSYCHIATRY" | i18n }}
          </mat-option>
          <mat-option
            [value]="DemoOrganisationType.LONGTERM_CARE"
            data-cy="organisation-type-longterm-care">
            {{ "demoOrganisationType.LONGTERM_CARE" | i18n }}
          </mat-option>
          <mat-option
            [value]="DemoOrganisationType.SPITEX"
            data-cy="organisation-type-spitex">
            {{ "demoOrganisationType.SPITEX" | i18n }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="light-form-field">
        <mat-label>{{
          ("monthlyServicesLabel" | i18n) ||
            "Wie viele Dienste werdet ihr ca. pro Monat buchen?"
        }}</mat-label>
        <input
          matInput
          [(ngModel)]="monthlyServices"
          type="number"
          required
          data-cy="monthly-services-input" />
      </mat-form-field>

      <div class="step-actions">
        <button
          class="primary-pill-button icon-right"
          (click)="submitDemo()"
          data-cy="submit-button">
          {{ ("submitButton" | i18n) || "Los gehts" }}
          <mat-icon svgIcon="chevron-right"></mat-icon>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Generating Demo Step -->
  <ng-container
    *ngIf="(currentStep$ | async) === DemoSetupStep.GENERATING_DEMO">
    <div
      class="step-container"
      data-cy="generating-demo-step">
      <h1 data-cy="generating-title">
        {{ ("generatingTitle" | i18n) || "Demo wird erstellt" }}
      </h1>

      <p
        data-cy="generating-text"
        class="description-text">
        {{
          ("generatingText" | i18n) ||
            "Wir erstellen nun deine Demo-Umgebung, bitte warten..."
        }}
      </p>

      <div
        class="progress-container"
        data-cy="progress-container">
        <div class="progress-bar-wrapper">
          <div
            class="progress-bar"
            [style.width.%]="loadingProgress$ | async"
            data-cy="progress-bar"></div>
        </div>
      </div>
      <p
        data-cy="current-step-text"
        class="current-step-text"
        *ngIf="
          !(redirecting$ | async) &&
            ((currentLoadingStep$ | async) || 0) < loadingSteps.length;
          else redirecting
        ">
        {{ (currentLoadingStep$ | async) || 0 }} /
        {{ loadingSteps.length }}
        {{ loadingSteps[(currentLoadingStep$ | async) || 0] }}
      </p>
      <ng-template #redirecting>
        <p
          data-cy="redirecting-text"
          class="current-step-text">
          {{ "redirectingToDashboard" | i18n }}
        </p>
      </ng-template>
    </div>
  </ng-container>
</div>
